export enum WebviewTenant  {
    AIRPASS = 'AIRPASS'
}